import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Чаршафи памучен сатен 100% памук | Над 100 размера по поръчка | GoToBed',
  description:
    'Долни чаршафи от памучен сатен 100% памук. Гладка и елегантна материя, над 100 размера. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Чаршафи памучен сатен от 100% памук – голям избор от размери
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Чаршафи памучен сатен от 100% памук – голям избор от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете долни чаршафи от памучен сатен (100% памук), които се
          отличават с гладка текстура, мекота и елегантен вид. Благодарение на специалния начин на
          тъкане памучният сатен има фина повърхност и лек естествен блясък, което придава
          по-луксозно усещане на спалното бельо. Предлагаме богато разнообразие от размери, за да
          откриете лесно подходящия чаршаф за вашето легло и матрак. Сред популярните размери са
          150/220, 160/240, 180/220, 200/220, 220/240, 240/260, 260/280 и 300/320 см.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако искате да разгледате всички модели, можете да посетите и:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            всички чаршафи
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi/1/1/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи ранфорс
          </Typography>
        </Box>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyCharshafiSaten />;
}

function SeoBodyCharshafiSaten() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Чаршафи от памучен сатен – 100% памук */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Чаршафи от памучен сатен – 100% памук
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Чаршафите от памучен сатен са отличен избор за хората, които търсят комфорт, мекота и
        по-луксозно усещане по време на сън. Памучният сатен е висококачествен 100% памучен плат,
        който се отличава с гладка повърхност, деликатен блясък и много приятен допир.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете долни чаршафи от памучен сатен, подходящи както за стандартни,
        така и за нестандартни размери матраци. Всеки чаршаф за матрак се изработва внимателно в
        България от сертифицирани памучни платове.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        За да създадете цялостен комплект спално бельо от същата материя, можете да комбинирате
        чаршафите и с:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/plikove-za-zavivka/1/4/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          пликове за завивки памучен сатен
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/kalufki/1/2/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          калъфки за възглавници памучен сатен
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/charshafi-s-lastik/1/3/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          чаршафи с ластик памучен сатен
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Чаршафи от памучен сатен в над 100 размера */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Чаршафи от памучен сатен в над 100 размера
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Нашите чаршафи от памучен сатен се предлагат в над 100 различни размера, което позволява
          лесно да намерите подходящ чаршаф по размер както за стандартни, така и за по-големи или
          нестандартни матраци.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Чаршафите могат да бъдат изработени за матраци с размери от 110/210 см до 360/360 см, като
          размерите се увеличават през 10 см.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Това ги прави подходящи както за единични легла, така и за големи двойни легла или
          нестандартни матраци.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Ако не намирате подходящ размер в стандартните магазини, нашите памучни чаршафи по размер
          са практично и удобно решение.
        </Typography>

        {/* H2: Какво представлява памучният сатен? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява памучният сатен?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Памучният сатен е 100% памучен плат, който се изработва чрез специален начин на тъкане.
          Благодарение на това материята има по-гладка повърхност и лек естествен блясък.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Предимства на памучния сатен:
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
          <li>&#10004; 100% естествен памук</li>
          <li>&#10004; гладка и мека на допир материя</li>
          <li>&#10004; деликатен блясък и по-луксозно усещане</li>
          <li>&#10004; добра дишаемост и комфорт по време на сън</li>
          <li>&#10004; устойчивост при пране и дълготрайна употреба</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Всички наши чаршафи от памучен сатен се изработват от платове със сертификат OEKO-TEX
          Standard 100, което гарантира безопасност и високо качество на текстила.
        </Typography>

        {/* H2: Предимства на чаршафите от памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на чаршафите от памучен сатен
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
          <li>&#10004; изработени от 100% памучен сатен</li>
          <li>&#10004; над 100 различни размера</li>
          <li>&#10004; размери от 110/210 до 360/360 см</li>
          <li>&#10004; подходящи за стандартни и нестандартни матраци</li>
          <li>&#10004; гладка, мека и приятна на допир материя</li>
          <li>&#10004; платове със сертификат OEKO-TEX Standard 100</li>
          <li>&#10004; произведени в България</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Чаршафите от памучен сатен са отличен избор, ако търсите по-фино и по-луксозно спално
          бельо.
        </Typography>

        {/* H2: Популярни размери чаршафи от памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери чаршафи от памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Най-често клиентите търсят чаршафи по размер като 220/240, 240/260 или 260/280, които
          позволяват удобно покриване и подпъхване под матрака.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Популярни размери чаршафи от памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред най-популярните размери са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            'чаршаф 150/220 (150х220) см',
            'чаршаф 160/240 (160х240) см',
            'чаршаф 180/220 (180х220) см',
            'чаршаф 200/220 (200х220) см',
            'чаршаф 220/240 (220х240) см',
            'чаршаф 240/260 (240х260) см',
            'чаршаф 260/280 (260х280) см',
            'чаршаф 300/320 (300х320) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на този широк избор можете лесно да намерите подходящ памучен чаршаф за
          матрак, дори когато размерът е по-нестандартен.
        </Typography>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички чаршафи се изработват индивидуално след направена поръчка, според избрания размер.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>

        {/* H2: Най-търсени размери чаршафи памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Най-търсени размери чаршафи памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          В нашия онлайн магазин можете да откриете чаршафи памучен сатен в много различни размери.
          Сред най-търсените размери от клиентите са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            'чаршаф 160/240 (160х240) см',
            'чаршаф 180/220 (180х220) см',
            'чаршаф 200/220 (200х220) см',
            'чаршаф 220/240 (220х240) см',
            'чаршаф 240/260 (240х260) см',
            'чаршаф 260/280 (260х280) см',
            'чаршаф 300/320 (300х320) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Тези размери са подходящи за различни видове матраци и позволяват удобно покриване и
          подпъхване под матрака.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за чаршафи памучен сатен
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какво представлява памучният сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Памучният сатен е 100% памучен плат с гладка повърхност и лек естествен блясък.
            Благодарение на специалния начин на тъкане материята е по-мека и по-гладка на допир,
            което придава по-луксозно усещане на спалното бельо.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свива ли се чаршафът от памучен сатен след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Както всички изделия от 100% памук, и чаршафите от памучен сатен могат да имат
            естествена свиваемост около 4–5% след първите пранета.
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Ако желаете чаршафът да има по-голяма покривност или да се подпъхва под матрака, е добре
            да изберете малко по-голям размер.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер чаршаф?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            За да изберете подходящ чаршаф за матрак, измерете ширината и дължината на матрака. След
            това изберете чаршаф със съответстващ размер.
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Ако предпочитате чаршафът да се подпъхва под матрака, изберете малко по-голям размер, за
            да има достатъчно плат за подпъхване.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са чаршафите от памучен сатен за големи матраци?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Предлагаме чаршафи от памучен сатен в над 100 различни размера, включително и за
            много големи матраци до 360/360 см.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват чаршафите?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички чаршафи от памучен сатен се изработват в България, специално за всяка поръчка и
            според избрания размер.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
